import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONSTANTS } from 'app/app.config';

@Injectable({
  providedIn: 'any'
})
export class PasswordsApiService {
  private API_URL = `${APP_CONSTANTS.API_URL}`;

  constructor(private http: HttpClient) {}

  sendResetUserPassword(email: string) {
    return this.http.post(`${this.API_URL}/passwords/actions/send-reset-password/${email}`, null);
  }
}
